






















































// @ is an alias to /src
import TopToolbar from "@/components/TopToolbar.vue";
import BottomNav from "@/components/BottomNav.vue";
import { Data, On, Route } from "@rocketbase/vue-extra-decorators";
import { Component, Vue } from "vue-property-decorator";
import { ItemRead, ItemReadLightDto, OverviewDto } from "@/swagger";

@Route({
  name: "Home",
  path: "/"
})
@Component({
  components: { TopToolbar, BottomNav }
})
export default class Home extends Vue {
  @Data({ default: "" })
  private searchValue!: string;

  @Data({ default: [] })
  private overviewDtos!: OverviewDto[];

  @Data({ default: [] })
  private filteredOverviewDtos!: OverviewDto[];

  @On("hook:mounted")
  private async onMounted() {
    await this.$store.dispatch("overview");
    await this.$store.dispatch("getLockers");
    await this.$store.dispatch("getTypes");

    const items = this.$store.state.items.slice();
    this.overviewDtos = items;
    this.filteredOverviewDtos = items;
  }

  private filterItems() {
    const items = JSON.parse(JSON.stringify(this.overviewDtos));

    if (this.searchValue.length === 0) {
      this.filteredOverviewDtos = items;
    } else {
      this.filteredOverviewDtos = items.filter((overviewDtos: OverviewDto) => {
        overviewDtos.items = overviewDtos.items?.filter(
          (itemReadLightDto: ItemReadLightDto) =>
            itemReadLightDto.name
              ?.toLocaleLowerCase()
              .includes(this.searchValue.toLocaleLowerCase())
        );
        if (overviewDtos.items && overviewDtos.items?.length > 0) return true;
        else return false;
      });
    }
  }

  private itemClicked(item: { name: string; date: string }) {
    this.$router.push("/overviewitem/" + item.name + "/" + item.date);
  }

  private createItem() {
    this.$router.push("/item/new");
  }
}
